import {
  GET_LIST_DANHSACHCHINHANH,
  GET_LIST_DANHSACHCHINHANH_SUCCESS,
  GET_LIST_DANHSACHCHINHANH_FAILURE,
} from "../../../actions/HeThong/DanhSachChiNhanh/actionTypes";
import moment from "moment";

const initialState = {
  List: [],
  iTotal: 0,
  isStartProcess: false,
};

const getListDanhSachChiNhanh = (state, action) => ({
  ...state,
  isStartProcess: true,
});

const getListDanhSachChiNhanhSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    iTotal: action.payload.TongBanGhi,
    isStartProcess: false,
  };
};

const getListDanhSachChiNhanhFailed = (state, action) => ({
  ...state,
  isStartProcess: false,
  List: [],
});

export const listDanhSachChiNhanhReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHCHINHANH:
      return getListDanhSachChiNhanh(state, action);
    case GET_LIST_DANHSACHCHINHANH_SUCCESS:
      return getListDanhSachChiNhanhSuccess(state, action);
    case GET_LIST_DANHSACHCHINHANH_FAILURE:
      return getListDanhSachChiNhanhFailed(state, action);
    default:
      return state;
  }
};

export default listDanhSachChiNhanhReducer;
